module.exports = __webpack_public_path__ + "vue/img/aicon (23).453328c6.png";